import React from 'react';
import './Shorterscrew.css';
import img1 from '../../../imgs/shortercycle.webp';
import img2 from '../../../imgs/specialiinject.webp';
import img3 from '../../../imgs/Servocontr.webp';

const data = [
  {
    img: img1,
    title: 'Shorter Cycle Time',
    desc: '20%~30% faster through synchronous pressure holding and charging process.'
  },
  {
    img: img2,
    title: 'High-Quality Preforms',
    desc: 'Specialized PET feeding screw improves preform’s quality.'
  },
  {
    img: img3,
    title: 'Energy Efficient System',
    desc: 'Servo control system saves 40%~60% electricity compared to common models.'
  }
];

const Shorterscrew = () => {
  return (
    <div className="shorterscrew-container">
      {data.map((item, idx) => (
        <div className="shorterscrew-card" data-aos="fade-down" key={idx}>
          <img src={item.img} alt={item.title} className="shorterscrew-img" />
          <div className="shorterscrew-text">
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Shorterscrew;
